import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import { AuthProvider } from "react-oidc-context";

const cognitoAuthConfig = {
  authority: process.env.REACT_APP_AUTHORITY,
  client_id: process.env.REACT_APP_CLIENT_ID,
  redirect_uri: process.env.REACT_APP_REDIRECT_URI,
  response_type: "code",
  scope: "email openid phone profile",

  onSigninCallback: (user) => {
    const returnTo = user?.state?.returnTo;
    if (returnTo) {
      // User was redirected mid-session — restore their original URL
      window.history.replaceState({}, document.title, returnTo);
    } else {
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <AuthProvider {...cognitoAuthConfig}>
      <App />
    </AuthProvider>
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
